import script from "./FooterMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterMenu.vue?vue&type=script&setup=true&lang=js"

import "./FooterMenu.vue?vue&type=style&index=0&id=a44a10aa&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a44a10aa"]])

export default __exports__